import { gql } from '@apollo/client'
import { sanitize } from '../helpers'
import AttachmentDetail from './fragments/AttachmentDetail'

export function mutateAttachment() {
  return gql(`
    ${AttachmentDetail}
    mutation AttachmentMutation(
      $description: String, 
      $title: String, 
      $url: String, 
      $target: MutationTargetInput, 
      $workflow: WorkflowInput) {
      AttachmentMutation(
        description: $description, 
        title: $title, 
        url: $url, 
        _target: $target, 
        _workflow: $workflow) {
        result {
          ...AttachmentDetail
        }
      }
    }
  `)
}

export async function createAttachment(client, attachment) {
  const variables = {}

  // If we have a session id we are doing an update.  Otherwise, it is a create
  if (attachment.id) {
    variables.target = { id: attachment.id, locale: attachment.contentLocale }
  }

  if (attachment.description) {
    variables.description = sanitize(attachment.description)
  }

  if (attachment.title) {
    variables.title = sanitize(attachment.title)
  }

  if (attachment.url) {
    variables.url = attachment.url
  }

  if (attachment.workflow) {
    variables.workflow = {
      action: 'TRANSITION',
      targetState: {
        state: attachment.workflow,
      },
    }
  }

  const response = await client.mutate({ mutation: mutateAttachment(), variables })
  return response?.data?.AttachmentMutation?.result
}

export async function updateAttachment({ client, attachment }) {
  return createAttachment(client, attachment)
}

export async function archiveAttachment(client, attachment) {
  const variables = {
    target: { id: attachment.id, locale: attachment.contentLocale },
    workflow: { action: 'DELETE' },
  }
  const response = await client.mutate({ mutation: mutateAttachment(), variables })
  return response?.data?.AttachmentMutation?.result
}
